import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

const VaZoPage = () => (
  <Layout>
    <SEO title="Vaderzoon dag" />
    <p>TBA</p>
  </Layout>
)

export default VaZoPage
